import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { HeadingComponent } from '@uc/shared/ui';
import { UniversityInformationCardComponent } from './university-information-card/university-information-card.component';
import {
	AcademicCapSvgComponent,
	ClockSvgComponent,
	HouseSvgComponent,
	UsersSvgComponent,
} from '@uc/shared/svg';
import { DecimalPipe } from '@angular/common';

@Component({
	selector: 'uc-university-information',
	templateUrl: './university-information.component.html',
	imports: [
		DecimalPipe,
		HeadingComponent,
		UniversityInformationCardComponent,
		UsersSvgComponent,
		HouseSvgComponent,
		ClockSvgComponent,
		AcademicCapSvgComponent,
	],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UniversityInformationComponent {
	totalStudents = input<number>();
	studentsInHalls = input<number>();
	fullTime = input<number>();
	avgTariffPoints = input<number>();
}
